module.exports = __webpack_public_path__ + "img/silver_vip_invalid.98cbbc77.png";